<script>
import Logo from '@/components/Logo.vue'
import niceFunctions from "@/helpers/niceFunctions"
export default {
    components: { Logo },
    computed: {
        publicPageColors() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPageColors : null },
        publicPage() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPage : null },
        customerName() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.customerName : {} },
        tabs() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.tabs : {} },
        availableBookings() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.availableBookings : {} },
        availableCourses() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.availableCourses : {} },
        settings() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.settings : null },
        hasSettings() { return this.settings },
        selectedPage() { return this.$route.name }
    },
    data() {
        return {      
          selectedTab: ''
        }
    },
    methods:
    {
        goTopage(page, item)
        {
            $("body").scrollTop(0);   
            if(page == 'bookingHoursAdd' || page == 'bookingDaysAdd')
            {
                this.$router.push({ name: niceFunctions.getPageName(page), params: { id: this.$route.params.id, bookingid: item.id } })
            }
            else if(page == 'courseDetails') {
                this.$router.push({ name: niceFunctions.getPageName(page), params: { id: this.$route.params.id, courseid: item.id } })
            }
            else
            {
                this.$router.push({ name: niceFunctions.getPageName(page), params: { id: this.$route.params.id } })
            }
        },
        goToTab(id)
        {
            this.$router.push({ name: niceFunctions.getPageName('tab'), params: { id: this.$route.params.id, tabid: id } })
        },
        getColor(location)
        {
        return niceFunctions.getColor(this.publicPageColors, location)
        },
        goToSalePage()
        {         
            this.$router.push({ name: 'saleHome'})         
        }, 

    }
}
</script>
<template>
<div v-if="publicPage != null && selectedPage != 'bookingHoursAdd' && selectedPage != 'bookingDaysAdd'" class="public-page" v-fade-in>
    <div class="public-footer" :style="{ 'background-color':  getColor('background_color')  }">
        <section>          
            <div>         
                <b>Meny</b> 
                <ul>
                    <li @click="goTopage('home')">
                        Hem     
                    </li>
                    <li @click="goTopage('community')">
                        {{hasSettings ? settings.Community.singular : '' }}
                    </li>
                    
                    <li v-for="tab in tabs" @click="goToTab(tab.id)">
                       {{ tab.name }}
                    </li>
                   
                    <li v-if="publicPage.include_image_gallery" @click="goTopage('imageGallery')">
                        {{hasSettings ? settings.ImageGallery.singular : '' }}
                    </li>                     
                    <li v-if="publicPage.include_contact"  @click="goTopage('contact')">
                        Kontakt      
                    </li>                  
                </ul>     
            </div>
            <div v-if="availableBookings.length > 0">
                <b>{{ hasSettings ? settings.BookingItem.plural : ''  }}</b>
                <ul>
                    <li v-for="booking in availableBookings">
                        <span v-if="booking.duration_unit == 'Timmar'" @click="goTopage('bookingHoursAdd', booking)">{{ booking.name }}</span>                        
                        <span v-else @click="goTopage('bookingDaysAdd', booking)">{{ booking.name }}</span>                        
                    </li>
                </ul>
            </div>
            <div v-if="availableCourses.length > 0">
                <b>{{ hasSettings ? settings.Course.plural : ''  }}</b>
                <ul>
                    <li v-for="course in availableCourses">
                        <span @click="goTopage('courseDetails', course)">{{ course.name }}</span>                                                                  
                    </li>
                </ul>
            </div>
            <div class="text-center">            
               <a href="https://www.jamii.se" target="_blank"><img src="../assets/imgs/new_logo.png" style="opacity: 0.2; width: 130px; cursor: pointer;"></a>
                <br><br>
                &copy; {{ new Date().getFullYear() }} {{ customerName }} 
                <br><br>
                <div v-if="settings.UserSetting_display_login_link.enabled"><b><a href="https://app.jamii.se" target="_blank">LOGGA IN</a></b></div>
            </div>
        </section>

        <p class="public-footer-samfallify" :style="{ 'color':  getColor('background_color') }"><a href="https://www.jamii.se" target="_blank"> {{ customerName }} är en del av jamiis&copy; härliga community.</a></p>                  
    </div>
</div>
</template>


<style scoped>
a {
    color: black;
}
.public-footer
{
    width:100%;
    filter: brightness(90%);
    padding: 70px 0px;
    position: relative;
}

.public-footer section
{
       display: flex;
    margin: auto;
    justify-content: center;
    gap: 90px;
    
}

.public-footer div
{
    max-width: 300px;
}

.public-footer b
{
    text-transform: uppercase;
}

.public-footer li:hover
{
    text-decoration: underline;
}

.public-footer-samfallify 
{
    position: absolute;
    bottom: 7px;
    right: 7px;
    font-size: 12px;  
    filter: brightness(70%);
    cursor:pointer;
}
.public-footer ul
{
    list-style: none;
    padding: 0px;
}

.public-footer li
{
   margin-bottom:10px;
   cursor: pointer;
}

.public-footer i
{
    filter: brightness(110%);
    font-size: 70pt;
    padding: 15px;
}

@media only screen and (max-width: 900px) {
    .public-footer section
    {
       flex-direction: column;
       gap: 30px;
       align-items: center;
    }
    
    .public-footer div
    {
        display: block;
        width: 100%;
        text-align: center;
        margin-bottom: 0px;
    }
}
</style>